module.exports = __webpack_public_path__ + "img/55.3089336b.webp";